import React from 'react';
import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { useAppSelector } from 'hooks/redux';

import TransactionEditFormProvider from './components/TransactionEditFormProvider';
import Legacy from './legacy';
import type { TransactionEditDialogProps } from './types';

function TransactionEditDialog(props: TransactionEditDialogProps) {
  const isV2 = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'transactionDetailsV2'));
  return isV2 || props.rootModalDrawer ? <TransactionEditFormProvider {...props} /> : <Legacy {...props} />;
}

export default TransactionEditDialog;
